import BaseVM from './base-vm'
import Utils from './utils'

const PublishPanelViewModel = function() { this.init.apply(this, arguments) }

PublishPanelViewModel.prototype = Kadenze.Util.extendClass(BaseVM, {
  summaries: ko.observableArray(),
  visibleImmediately: ko.observable(false),
  isLastPage: ko.observable(false),

  init(data, wizard) {
    this.super('init', wizard, data)

    this.data = data

    ko.mapping.fromJS(
      {
        start_date: data.start_date,
        start_date_string: data.start_date_string,
        visible_on: data.visible_on,
        visible_on_string: data.visible_on_string,
        end_date: data.end_date,
        end_date_string: data.end_date_string,
        status: data.status,
        isPublished: data.isPublished,
        isDraft: data.isDraft,
      },
      {},
      this
    )

    this.canPublish = ko.computed(() => {
      return !this.isPublished() && this.isLastPage()
    })

    this.isSaved = ko.computed(() => !!this.id())

    this.saveButtonText = ko.computed(() => {
      return this.isSaved() ? I18n.t('dict.update') : I18n.t('dict.save')
    })

    if (!this.isSaved()) {
      this.setVisibleOnNow()
    } else {
      this.visibleImmediately(false)
    }

    // Watch for user changing date, need to be able to tell the difference
    // between KO binding and the user changing the visible_on observable
    $('.js-visible-on-trigger').on('click', () => this.visibleImmediately(false))

    this.visible_on.subscribe(value => this.visibleImmediately(false))
  },

  saveSession() {
    return this.createOrUpdate(this.wizard.getAllData())
  },

  publishSession() {
    this.publish(this.wizard.getAllData(), $.proxy(this.onStatusUpdate, this))
  },

  unpublishSession() {
    this.unpublish(this.wizard.getAllData())
      .done($.proxy(this.onStatusUpdate, this))
  },

  onStatusUpdate(response) {
    this.updateStatus(JSON.parse(response.session))
  },

  updateStatus(session) {
    this.status(session.status)
    this.isPublished(session.isPublished)
    this.isDraft(session.isDraft)
  },

  destroySession() {
    Kadenze.UIUtil.confirmAction(
      'Are you sure you want to delete this session?',
      () => {
        this.successMessage = 'Successfully removed session.'

        const redirectUrl = Kadenze.Routes.course_sessions_path(this.data.course_id)

        if (this.isSaved) {
          const request = this.destroy(this.wizard.getAllData())
          request.done(() => {
            Kadenze.Request.pjax({ url: redirectUrl, container: '#main-pjax-container' })
          })
        }
      }
    )
  },

  previewSession(item, event) {
    const response = this.saveSession()

    response.done(data => {
      if(data.session) {
        const session = JSON.parse(data.session)

        window.location = Kadenze.Routes.course_session_path(
          session.course_id,
          session.slug,
          {
            preview: true,
            exit_path: Kadenze.Routes.edit_course_session_path(session.course_id, session.slug)
          }
        )
      } else {
        new Kadenze.Notice.error({ message: data.errors })
      }
    })
  },

  formatDateForSubmission(date) {
    if(_.isFunction(date)){
      return _.isEmpty(date) || s.isBlank(date()) ?
        '' :
        Kadenze.Util
          .getMomentDateFromObservable(date)
          .utc()
          .format(I18n.t('date.formats.js_default_with_zone'))
    } else {
      return s.isBlank(date) ?
        '' :
        moment(date).utc().format(I18n.t('date.formats.js_default_with_zone'))
    }
  },

  isVisibleNow() {
    const date = this.visible_on

    return this.visibleImmediately() || (
      _.isFunction(date) && s.isBlank(date())
    ) || (!_.isUndefined(date) && s.isBlank(date))
  },

  setVisibleOnNow() {
    this.visible_on(this.formatDateForSubmission(this.start_date))
    this.visibleImmediately(true)
  },

  reBind(session) {
    if (this.visibleImmediately() && session.isPublished) {
      this.visibleImmediately(false)
      this.updateStatus(session)
    } else if (this.visibleImmediately()) {
      this.setVisibleOnNow()
    }
  },

  prepareData() {
    if(this.isVisibleNow()) {
      this.visible_on_string(this.formatDateForSubmission(new Date()))
    } else {
      this.visible_on_string(this.formatDateForSubmission(this.visible_on))
    }

    this.start_date_string(this.formatDateForSubmission(this.start_date))
    this.end_date_string(this.formatDateForSubmission(this.end_date))
  }
})

export default PublishPanelViewModel
